import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import styles from "./Toolbar.module.css";
import ToolModal from "./ToolModal";

const Toolbar = () => {
  const [isPanelOpen, setIsPanelOpen] = useState(false);
  const [showToolModal, setShowToolModal] = useState(false);
  const [activeTool, setActiveTool] = useState(null);

  const openPanel = () => {
    setIsPanelOpen((prev) => !prev);
  };

  const closePanel = () => {
    setIsPanelOpen(false);
  };

  const handleToolClick = (tool) => {
    setActiveTool(tool);
    setShowToolModal(true);
    setIsPanelOpen(false);
  };

  const closeToolModal = () => {
    setShowToolModal(false);
    setActiveTool(null);
  };

  return (
    <div className={styles.toolbarRoot}>
      <Button
        type="button"
        variant="primary"
        className={styles.floatingButton}
        onClick={openPanel}
        aria-label="Alətlər panelini aç"
      >
        <i className="bi bi-pencil-fill" />
      </Button>

      {isPanelOpen && (
        <div className={styles.panel}>
          <div className={styles.panelHeader}>
            <span>Alətlər paneli</span>
            <Button type="button" variant="light" className={styles.closeButton} onClick={closePanel} aria-label="Paneli bağla">
              <i className="bi bi-x-lg" />
            </Button>
          </div>

          <div className={styles.toolsList}>
            <Button type="button" variant="light" className={styles.toolButton} onClick={() => handleToolClick("notepad")}>
              <i className="bi bi-journal-text me-2" />
              Notepad
            </Button>
            <Button type="button" variant="light" className={styles.toolButton} onClick={() => handleToolClick("paint")}>
              <i className="bi bi-palette2 me-2" />
              Rəsm
            </Button>
          </div>
        </div>
      )}

      <ToolModal show={showToolModal} onHide={closeToolModal} tool={activeTool} />
    </div>
  );
};

export default Toolbar;